import { SignInForm } from "./SignInForm";
import { useEffect, useState } from "react";
import { AuthPage } from "../AuthPage";
import { useRecoilState } from "recoil";
import { userAuthState } from "../../../state";
import { useNavigate } from "react-router";
import { route } from "../../../routes";

export const SignInScreen = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const [userAuthData] = useRecoilState(userAuthState);

  useEffect(() => {
    const isUserLoggedIn = userAuthData !== null;
    if (isUserLoggedIn) {
      navigate(route.dashboard());
    }
  }, [userAuthData, navigate]);

  return (
    <AuthPage isLoading={isLoading}>
      <SignInForm setIsLoading={setIsLoading} isLoading={isLoading} />
    </AuthPage>
  );
};
